<template fullscreen>
  <div>
    <v-layout row justify-center>
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card class="pa-5 ma-0">
          <v-card-text class="pt-2 scarico">
            <h1 class="display-bold has-border-bottom">Scarico</h1>
            <v-btn icon @click="chiudi()" style="position: absolute; top:5px; right: 5px;">
              <v-icon>close</v-icon>
            </v-btn>
            <v-layout class="mt-2">
              <h2>{{dati.ragioneSociale}}</h2>
            </v-layout>
            <v-list class="pa-0 ma-0">
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>access_time</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Consegna prevista: {{dati.tempoPrevisto ? dati.tempoPrevisto.substr(11,5): ''}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-list three-line class="pa-0 ma-0">
              <v-list-tile @click="apriNavigatore()">
                <!-- Apre direttamente google maps con la funzione di navigatore! -->
                <v-list-tile-action>
                  <v-icon>directions</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Indirizzo</v-list-tile-title>
                  <v-list-tile-sub-title style="text-transform: capitalize">
                    {{dati.indirizzo}}
                    <br />
                    {{dati.localita}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <!-- <v-list two-line>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>insert_drive_file</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Documenti</v-list-tile-title>
                  <v-list-tile-sub-title>{{ dati.documenti && dati.documenti.length > 0 ? dati.documenti : 'Nessun documento' }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>-->

            <!-- <h2>Colli</h2> -->
            <!-- <v-layout row>
              <v-flex xs3>
              </v-flex>
              <v-flex xs3 style="text-align: center">
                <strong>Caricato</strong>
              </v-flex>
              <v-flex xs3 style="text-align: center">
                <strong>Scaricato</strong>
              </v-flex>
          
            </v-layout>-->

            <v-form class="form-scarico">
              <v-layout>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Scatole!=0">
                    Scatole
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Scatole"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Fasci!=0">
                    Fasci
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Fasci"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Latte!=0">
                    Latte
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Latte"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Ritiro!=0">
                    Ritiro
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Ritiro"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Barre!=0">
                    Barre
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Barre"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Pallet!=0">
                    Pallet
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Pallet"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2>
                  <div v-show="dettRow.colli_Altro!=0">
                    Altro
                    <v-text-field
                      box
                      single-line
                      type="number"
                      hide-details
                      v-model="dettRow.colli_Altro"
                      readonly
                      reverse
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs3 pr-2 pb-2></v-flex>
              </v-layout>
            </v-form>
          </v-card-text>

          <v-btn
            v-if="this.dati.scaricato == false"
            width="200px"
            block
            dark
            id="btnScarico"
            large
            @click="scaricaConsegna()"
            :loading="attesaScarico"
          >Scarica</v-btn>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, required: true },
    dati: { type: Object },
    datiDettaglio: { type: Object }
  },
  data() {
    return {
      dettRow: {},

      attesa: false,
      attesaScarico: false
    };
  },

  methods: {
    caricaDati() {
      if (!this.dialog) return;

      // Reset
      this.dettRow = {};
      this.attesaScarico = false;

      this.dettRow = Object.assign({}, this.datiDettaglio);
    },

    scaricaConsegna() {
      // NOTA: la variabile viene resettata in caricaDati (la dialog si chiude al termine)
      this.attesaScarico = true;

      // Data scarico
      this.dettRow.dataScarico = this.$functions.getDateIso();

      this.$emit("scaricato", this.dettRow, this.dati.prog);
    },

    chiudi() {
      this.$emit("chiudi");
    },

    apriNavigatore() {
      let indirizzoUrl = this.dati.indirizzo.replace(/ /gi, "+");
      let localitaUrl = this.dati.localita.replace(/ /gi, "+");

      let urlMaps =
        "https://www.google.com/maps/dir/?api=1&destination=" +
        indirizzoUrl +
        ",+" +
        localitaUrl +
        "&dir_action=navigate";

      if (urlMaps != "") {
        if (this.$functions.CordovaApp())
          window.cordova.InAppBrowser.open(urlMaps, "_system");
        else window.open(urlMaps, "_blank");
      }
    }
  },

  mounted() {
    this.caricaDati();
  },

  watch: {
    dialog() {
      this.caricaDati();
    }
  }
};
</script>